import React from "react";
import { UserInfo } from "./auth.typer";

export type AuthContextType = {
  userInfo?: UserInfo | null;
};

export const AuthContext = React.createContext<AuthContextType>({
  userInfo: undefined,
});
